import { createFileRoute } from '@tanstack/react-router'
import { useState } from 'react'

import { useShellClient } from '@/components/clients/shell-client'
import { Frame } from '@/components/frame'
import type { OpportunitiesSearch } from '@/components/opportunities/opportunities-search-schema'
import { OpportunitiesWorkspace } from '@/components/opportunities/opportunities-workspace'

export const Route = createFileRoute('/_app/clients/$clientId/affaires')({
  component: ClientOpportunitiesPage,
})

/**
 * Les affaires du client. Les filtres restent locaux : les porter dans l'URL
 * alourdirait chaque lien vers la page sans qu'on se les envoie jamais.
 */
function ClientOpportunitiesPage() {
  const client = useShellClient()
  const [filters, setFilters] = useState<OpportunitiesSearch>({})
  return (
    <Frame>
      <OpportunitiesWorkspace
        search={filters}
        fixedClient={{ id: client.id, name: client.name }}
        onSearchChange={(next) => {
          setFilters((current) => ({ ...current, ...next }))
        }}
      />
    </Frame>
  )
}
